import { generateSetChild, generateUpdateArrayChild } from '@/helpers/VuexHelpers'
import { service } from '@/service'
import { config } from '@/config'

export default {
	namespaced: true,
	state: {
		outdoorDeliveries: [],
		channels: []
	},
	actions: {
		async loadOutdoorDeliveryPoints({ commit, dispatch }, { campaignId, accumulatorGroup = null } = {}) {
			const result = await service.loadOutdoorDeliveryPoints({ campaignId, brand: config.BRAND, accumulatorGroup })
			if (result?.outdoorDeliveries) {
				commit('setOutdoorDeliveries', { item: result.outdoorDeliveries })
				commit('setChannels', { item: Object.values(result.dereferencedChannels) })
			}
		},
	},
	getters: {
		outdoorDeliveryPoints (state, getters) {
			return (state.outdoorDeliveries || [])
				.map(location => {
					let channels = location.channels
						.map(code => {
							const location = getters.outdoorDeliveryChannels.find(channel => channel.code === code)
							return {
								...location,
								image: location.location?.images?.find(image => image.code == 'location_assortment_image')?.path || null
							}
						})
						.sort((a, b) => a.name.localeCompare(b.name) || a.location.brand.localeCompare(b.location.brand))

					channels = [
						...channels.filter(location => location.location.brand == config.BRAND),
						...channels.filter(location => location.location.brand != config.BRAND),
					]

					return {
						...location,
						channels
					}
				})
				.sort((a, b) => a.title.localeCompare(b.title))
		},
		outdoorDeliveryChannels (state) {
			return state.channels || []
		},
		outdoorDeliveryPointsByRegion(stage, getters) {
			let regions = Object
				.entries(getters.outdoorDeliveryPoints.reduce((regions, location) => {
					const region = location.region
					if (!Array.isArray(regions[region])) {
						regions[region] = []
					}
					regions[region].push(location)
					return regions
				}, {}))
				.map(([code, locations]) => {
					return {
						code,
						locations
					}
				})
				.sort((a, b) => a.code.localeCompare(b.code))
			return regions
		}
	},
	mutations: {
		setOutdoorDeliveries: generateSetChild("outdoorDeliveries"),
		setChannels: generateSetChild("channels"),
	}
}
